module.exports = __webpack_public_path__ + "static/media/hint04.b9fe573f.jpg";